import { Pagination } from '@material-ui/lab';
import { Inline, useResponsiveValue } from '@superdispatch/ui';
import { Box } from '@superdispatch/ui-lab';
import { APIPageResponse } from 'shared/api/CarrierAPIClient';
import { trackLoadboardEvent } from '../LoadboardAnalytics';
import { usePostingsPageContext } from './PostingsPageContext';

interface Props {
  pagination?: APIPageResponse['pagination'];
}

export function PostingListPagination({ pagination }: Props) {
  const siblingCount = useResponsiveValue(0, 3);
  const { params, setParams } = usePostingsPageContext();

  if (!pagination || pagination.count <= params.current_page_size) {
    return null;
  }

  return (
    <Box
      padding="small"
      borderWidth="small"
      backgroundColor="White"
      borderColor="Silver400"
    >
      <Inline horizontalAlign={['center', 'left']}>
        <Pagination
          siblingCount={siblingCount}
          page={params.current_page + 1}
          count={Math.ceil(pagination.count / params.current_page_size)}
          onChange={(_, nextPage) => {
            setParams((prev) => ({ ...prev, current_page: nextPage - 1 }), {
              navigation: 'replace',
            });

            trackLoadboardEvent({
              name: 'SLB: UI Interaction',
              type: 'Pagination: Clicked Page Number',
            });
          }}
        />
      </Inline>
    </Box>
  );
}
